import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';

const initialState = {
  open: false,
};

const setDrawerOpen = (state, action) => {
  return updateObject(state, {
		open: action.open
	});
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_DRAWER_OPEN: return setDrawerOpen(state, action);

    default: return state;
  }
};

export default reducer;